import { useContext } from "react";
import { Context } from "../../../../context/Context";
import { Button, Copy, GripVertical, Plus } from "../../../ui";

const scrollToSection = (id) => {
  document.getElementById(`food-section-${id}`)?.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function FoodSidebar({ sections, editable, onAddSection, onCopyAll, dragSectionId, sectionDragProps }) {
  const { lang } = useContext(Context);
  const isArabic = lang === "ar";
  return (
    <aside className="food-sidebar">
      <div className="food-sidebar-title">{isArabic ? "الأقسام" : "Sections"}</div>

      {editable && onCopyAll && (
        <Button className="food-add-section food-sidebar-copy-btn" type="button" variant="primary" appearance="soft" size="sm" rounded icon={<Copy size={16} />} title={isArabic ? "نسخ الأقسام" : "Copy sections"} aria-label={isArabic ? "نسخ الأقسام" : "Copy sections"} onClick={onCopyAll} />
      )}

      {sections.map((section) => {
        const dragProps = sectionDragProps ? sectionDragProps(section) : {};
        return (
          <div key={section._id} className={`food-sidebar-item ${dragSectionId === String(section._id) ? "is-dragging" : ""}`} onDragEnter={dragProps.onDragEnter} onDragOver={dragProps.onDragOver}>
            {dragProps.draggable && (
              <button className="food-sidebar-drag-btn" type="button" draggable onDragStart={dragProps.onDragStart} onDragEnd={dragProps.onDragEnd} title={isArabic ? "اسحب لترتيب القسم" : "Drag to reorder"} aria-label={isArabic ? "اسحب لترتيب القسم" : "Drag to reorder"}>
                <GripVertical size={16} />
              </button>
            )}
            <button className="food-sidebar-section-btn" onClick={() => scrollToSection(section._id)} type="button">
              <span>
                {section.order}. {section.name?.ar || section.name?.en}
              </span>
              <small>{section.items.length}</small>
            </button>
          </div>
        );
      })}

      {editable && (
        <Button className="food-add-section" type="button" variant="primary" appearance="soft" size="sm" rounded icon={<Plus size={16} />} onClick={onAddSection}>
          {isArabic ? "قسم جديد" : "New section"}
        </Button>
      )}
    </aside>
  );
}
